import { apiClient } from './client'
import type { MergeExactJob } from './entity-resolution-groups'

export const RESOLUTION_BAND_IDS = [
  'below_80',
  '80_90',
  '90_95',
  '95_99',
  '99_100',
  'exact',
  'unknown',
] as const
export type ResolutionBandId = (typeof RESOLUTION_BAND_IDS)[number]

export interface ResolutionBand {
  id: ResolutionBandId
  label: string
  min_score: number | null
  max_score: number | null
  group_count: number
  candidate_count: number
  percentage: number
  /** Missing on historical assistant artifacts; refresh before merging. */
  bulk_eligible_group_count?: number
  blocked_group_count?: number
}

export interface ResolutionIdentityChecks {
  conflict_groups: number
  review_groups: number
  supported_groups: number
  unknown_groups: number
  conflict_fields: Record<string, number>
  review_fields: Record<string, number>
}

export interface ResolutionSummary {
  case_id: string
  snapshot_id: string
  total_groups: number
  total_candidates: number
  bands: ResolutionBand[]
  score_basis: string
  identity_checks?: ResolutionIdentityChecks
}

export interface AssistantMergeRequest {
  snapshot_id: string
  band_ids: ResolutionBandId[]
}

const base = (caseId: string) => `/v1/cases/${caseId}/entity-resolution/assistant`

export const resolutionAssistantApi = {
  summary: (caseId: string) => apiClient.get<ResolutionSummary>(`${base(caseId)}/summary`),
  merge: (caseId: string, body: AssistantMergeRequest) =>
    apiClient.post<MergeExactJob>(`${base(caseId)}/merge`, body),
  status: (caseId: string, jobId: string) =>
    apiClient.get<MergeExactJob>(`${base(caseId)}/merge/status`, { params: { job_id: jobId } }),
}
